import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { viewConfig } from './../config/config.constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/**
 * Class responsible of UI configuration
 */
var UiConfigService = /** @class */ (function () {
    function UiConfigService(router) {
        this.router = router;
        this.config = new Subject();
        this.status = true;
        this.queryParam = {};
    }
    /**
     * Pull view configuration from constants
     */
    UiConfigService.prototype.setup = function (routeData) {
        var data = viewConfig.get(routeData) || {
            heading: true,
            greeting: true,
            tabs: true,
            footer: true,
            cssClass: ''
        };
        this.config.next(data);
        return data;
    };
    /**
     * Save or merge opportunityID and campaignID in _config
     */
    UiConfigService.prototype.saveQueryParams = function (data, opt) {
        if (opt === void 0) { opt = 'save'; }
        if (data) {
            this.queryParam = opt === 'merge' ? Object.assign(this.queryParam, data) : data;
        }
    };
    UiConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UiConfigService_Factory() { return new UiConfigService(i0.ɵɵinject(i1.Router)); }, token: UiConfigService, providedIn: "root" });
    return UiConfigService;
}());
export { UiConfigService };
